import React from "react";
import PropTypes from "prop-types";
import { Prompt } from "react-router-dom";
import {
  fetchHraResult,
  fetchHraResultDetail,
  fetchWellnessPriorities,
  setWellnessPriorities,
  setUnsubmittedPriorities,
} from "actions/hraResultActions";
import { Loader } from "cxa-components";
import FaceAgeing from "./faceAgeing";
import WellnessPrioritiesForm from "./WellnessPrioritiesForm";
import { connect } from "react-redux";
import LifestyleAgeingNav from "../LifestyleAgeingNav";

import SetInterval from "components/common/CallbackOnInterval";
import { intlShape, injectIntl } from "react-intl";
import { intlFormat } from "i18n/util";

import HraResultIncomplete from "./hraResultIncomplete";
import HealthReview from "./healthReview";
import lodash from "lodash";

class HraResult extends React.Component {
  constructor(props) {
    super(props);
    this.getResultDetail = this.getResultDetail.bind(this);
    this.handleUnsubmittedPriorities = this.handleUnsubmittedPriorities.bind(this);
  }

  componentDidMount() {
    const { fetchHraResult, fetchHraResultDetail, currentRiskDomain } = this.props;

    fetchHraResult();
    fetchHraResultDetail(currentRiskDomain);
  }

  componentDidUpdate() {
    const {
      fetchWellnessPriorities,
      wellnessPrioritiesEnabled,
      isFetchingWellnessPriorities,
      wellnessPrioritiesFetched,
    } = this.props;

    if (wellnessPrioritiesEnabled && !wellnessPrioritiesFetched && !isFetchingWellnessPriorities) {
      fetchWellnessPriorities();
    }
  }

  getResultDetail(riskDomain) {
    this.props.fetchHraResultDetail(riskDomain);
  }

  handleUnsubmittedPriorities(values) {
    const { setUnsubmittedPriorities, wellnessPrioritiesInitialValues } = this.props;
    const valuesChanged = !lodash.isEqual(wellnessPrioritiesInitialValues, values);

    setUnsubmittedPriorities(valuesChanged);
  }

  render() {
    const {
      faceAgeingData,
      fetchHraResult,
      isFetchingHraResult,
      isFetchingWellnessPriorities,
      wellnessPrioritiesEnabled,
      wellnessPriorities,
      wellnessPrioritiesInitialValues,
      setWellnessPriorities,
      wellnessPrioritiesSubmitting,
      unsubmittedPriorities,
      intl,
      hraQuestionsAnswered,
    } = this.props;

    const {
      ageRangeList,
      healthyPhotosList,
      unhealthyPhotosList,
      faceAgingCompleted,
      agingPhotoSubmitted,
    } = faceAgeingData;

    if (isFetchingHraResult || isFetchingWellnessPriorities) {
      return <Loader />;
    }

    if (!isFetchingHraResult && !hraQuestionsAnswered) {
      return <HraResultIncomplete />;
    }

    return (
      <div>
        <LifestyleAgeingNav />
        {!faceAgingCompleted &&
          agingPhotoSubmitted && <SetInterval apiCall={fetchHraResult} interval={10000} />}
        <FaceAgeing
          ageRangeList={ageRangeList}
          healthyPhotosList={healthyPhotosList}
          unhealthyPhotosList={unhealthyPhotosList}
          faceAgingCompleted={faceAgingCompleted}
          agingPhotoSubmitted={agingPhotoSubmitted}
        />
        <HealthReview riskItemClicked={this.getResultDetail} />
        {wellnessPrioritiesEnabled &&
          wellnessPriorities.data && (
            <div>
              <WellnessPrioritiesForm
                initialValues={wellnessPrioritiesInitialValues}
                onSubmit={setWellnessPriorities}
                onChange={this.handleUnsubmittedPriorities}
                submitting={wellnessPrioritiesSubmitting}
                {...wellnessPriorities}
              />
              <Prompt
                when={unsubmittedPriorities}
                message={intlFormat(intl, {
                  id: "PRIORITY_NOTSAVED_WARNING_MESSAGE",
                })}
              />
            </div>
          )}
      </div>
    );
  }
}

HraResult.propTypes = {
  error: PropTypes.object,
  isFetchingHraResult: PropTypes.bool,
  isFetchingWellnessPriorities: PropTypes.bool,
  wellnessPrioritiesEnabled: PropTypes.bool,
  wellnessPrioritiesSubmitting: PropTypes.bool,
  wellnessPrioritiesSubmitted: PropTypes.bool,
  unsubmittedPriorities: PropTypes.bool,
  wellnessPrioritiesFetched: PropTypes.bool,

  fetchHraResult: PropTypes.func,
  fetchHraResultDetail: PropTypes.func,
  fetchWellnessPriorities: PropTypes.func,
  setWellnessPriorities: PropTypes.func,
  setUnsubmittedPriorities: PropTypes.func,

  faceAgeingData: PropTypes.object,
  resultDetail: PropTypes.object,
  currentRiskDomain: PropTypes.string,
  wellnessPriorities: PropTypes.object,
  wellnessPrioritiesInitialValues: PropTypes.object,
  intl: intlShape.isRequired,
  hraQuestionsAnswered: PropTypes.bool,
};

const mapStateToProps = function(store) {
  return {
    error: store.error,
    isFetchingHraResult: store.hraResult.isFetching,
    isFetchingWellnessPriorities: store.wellnessPriorities.isFetching,
    faceAgeingData: store.hraResult.faceAgeingData,
    resultDetail: store.hraResultDetail.resultDetail,
    currentRiskDomain: store.hraResultDetail.currentRiskDomain,
    wellnessPrioritiesEnabled: store.hraResult.prioritiesEnabled,
    wellnessPriorities: store.wellnessPriorities.priorities,
    wellnessPrioritiesInitialValues: store.wellnessPriorities.initialValues,
    wellnessPrioritiesSubmitting: store.wellnessPriorities.submitting,
    wellnessPrioritiesSubmitted: store.hraResult.prioritiesSubmitted,
    unsubmittedPriorities: store.wellnessPriorities.unsubmittedPriorities,
    wellnessPrioritiesFetched: store.wellnessPriorities.fetched,
    hraQuestionsAnswered: store.hraResult.hraQuestionsAnswered,
  };
};

const mapDispatchToProps = {
  fetchHraResult,
  fetchHraResultDetail,
  fetchWellnessPriorities,
  setWellnessPriorities,
  setUnsubmittedPriorities,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(HraResult));



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/results/hraResult.jsx